import React, { useContext, useState } from "react";
import "./CSS/SaleCardNew.css";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Typography } from "@mui/material";
import { DiscoverContext } from "./DiscoverContext";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";

const SaleCardNew = ({ sell, removeFromWishlist = false, id, params }) => {
  const { MarkInterested, RemoveFromWishlist } = useContext(DiscoverContext);
  const [isAdded, setIsAdded] = useState(false);

  const ButtonClick = () => {
    if (removeFromWishlist) {
      RemoveFromWishlist(id, true, params);
      return;
    }
    MarkInterested(sell?.id);
    setIsAdded(true);
  };

  // Price / discount
  const price = sell?.post_details?.pricing ?? 0;
  const discounted = sell?.post_details?.discounted_price ?? 0;
  const isFree = !!sell?.post_details?.free;

  const discountPct =
    price && discounted && price > 0
      ? Math.round(((price - discounted) / price) * 100)
      : 0;

  const title = sell?.post_details?.title ?? "Untitled";
  const location = sell?.post_details?.location ?? "";
  const category = sell?.post_details?.category ?? "—";

  const mainImage =
    sell?.sell_images && sell?.sell_images.length
      ? sell?.sell_images[0]?.image
      : "/Image/Discover/Sale/discover_sale.png";

  // ======= Determine interested / going counts =======
  const stringToHash = (str = "") => {
    let hash = 5381;
    for (let i = 0; i < str.length; i++) {
      hash = (hash << 5) + hash + str.charCodeAt(i);
      hash = hash & hash;
    }
    return Math.abs(hash);
  };

  const seedString = (sell?.post_details?.title || String(sell?.id || "")).toString();
  const h1 = stringToHash(seedString);
  const h2 = stringToHash(seedString + "_v2");

  const interestedCount = 5 + (h1 % 196);
  let goingCount = Math.max(1, Math.floor((interestedCount * ((h2 % 50) + 10)) / 100));
  if (goingCount > interestedCount) goingCount = interestedCount;
  // ================================================

  return (
    <div className="sale_page_sale_card_container" role="article">
      <div className="sale_page_sale_card_top">
        <img className="sale_page_sale_card_image" src={mainImage} alt={title} />
      </div>

      <div className="sale_page_sale_card_mid">
        <div className="sale_page_sale_time_date">
          <span className="sale_page_sale_date">
            {isFree ? (
              <Typography sx={{ fontSize: "18px", color: "#000", fontWeight: 600 }}>
                Free
              </Typography>
            ) : (
              <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
                <Typography sx={{ fontSize: "18px", color: "#000", fontWeight: 600 }}>
                  ₹ {discounted ? discounted : price}
                </Typography>
                {discounted && price ? (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      textDecoration: "line-through",
                      fontWeight: 600,
                    }}
                  >
                    ₹ {price}
                  </Typography>
                ) : null}
                {discountPct > 0 ? (
                  <Typography sx={{ fontSize: "14px", color: "green", fontWeight: 600 }}>
                    {discountPct}% off
                  </Typography>
                ) : null}
              </Box>
            )}
          </span>
        </div>

        <div className="sale_page_sale_title">
          <p className="sale_page_sale_title_text" style={{ margin: 0 }}>
            {title.length > 45 ? title.slice(0, 42) + "..." : title}
          </p>
        </div>

        <div className="sale_page_sale_mode">
          <span className="sale_page_sale_location_span">
            <img
              src="/Image/DashImage/RightSidebar/connect_icon.svg"
              alt="loc icon"
              style={{ width: "9px", filter: "grayscale(100%)", marginRight: 5 }}
            />
            <span className="sale_page_sale_location_text">
              {location.length > 65 ? `${location.slice(0, 62)}...` : location}
            </span>
          </span>

          <span
            className="sale_page_sale_category_span"
            style={{
              display: "block",
              marginTop: "3px",
              color: "#666666",
              fontSize: "14px",
            }}
          >
            Category: {category}
          </span>
        </div>
      </div>

      <div className="sale_page_sale_card_bottom">
        <div className="sale_page_sale_interested">
          <span>{interestedCount} interested :</span>
          <span style={{ marginLeft: 8 }}>{goingCount} going</span>
        </div>

        <div className="sale_page_sale_interested_button_cont">
          <button
            onClick={ButtonClick}
            className="sale_page_sale_interested_button"
            aria-label={removeFromWishlist ? "Remove from wishlist" : "Mark as interested"}
            type="button"
          >
            {removeFromWishlist ? (
              <DeleteOutlineRoundedIcon sx={{ color: "#fff", mr: 0.5 }} />
            ) : (
              <CalendarMonthIcon sx={{ color: "#fff", mr: 0.5 }} />
            )}
            {removeFromWishlist
              ? "Remove from wishlist"
              : isAdded
              ? "Added to Favourites"
              : "Interested"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SaleCardNew;
